var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 pattern mb-4",staticStyle:{"max-height":"500px","min-height":"500px","overflow":"hidden"}},[_c('div',{staticClass:"container mt-4"},[_c('b-jumbotron',{attrs:{"header":"404","lead":"Page not found"}},[_c('b-button',{attrs:{"href":"/"}},[_vm._v("Go Home")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }